import React from 'react'
import { useSelector } from 'react-redux'
import { useInView } from 'react-intersection-observer'
import Wysiwyg from '../wysiwyg'
import ButtonArrow from '../buttonArrow'

import semiroundShape from '../../icons/semiround-shape.svg'
import hexagonShape from '../../icons/hexagon-shape.svg'
import roundShape from '../../icons/hexagon-shape.svg'

import transformLink from '../../utils/transformLink'
import slugify from 'slugify'

import trads from '../../intl/trads.json'

const Rates = ({data}) => {
  const lang = useSelector(state => state.lang)
  const { ref, inView} = useInView({ threshold: 0.3, triggerOnce: true})

  return (
    <div className={inView ? 'has-anim' : ''} ref={ref}>
      <div className="row">
        <div className="col-12 lg-col-7 mx-auto">
          <h2 className="text-center title title-slice mb-8 scroll-anim-el">{data.title}</h2>
        </div>
      </div>

      <div className={`row -mb-10 ${data.items.length < 3 ? 'justify-center' : ''}`}>
        {data.items.map((item, i) => {
          item = item.fields ? item.fields : item
          
          let cta = null
          let url = null
          let contentTypeContentful = null

          if (item.cta !== null && item.cta !== undefined) {
            cta = (item.cta.fields) ? item.cta.fields : item.cta
            const transformLinkResult = transformLink(cta, true, false)
            url = transformLinkResult.url
            contentTypeContentful = transformLinkResult.contentTypeContentful
          }

          return (
            <div key={i} className={`flex mb-10 scroll-anim-el scroll-anim-el--${i + 2} col-12 ${item.isFull ? 'xl-col-12' : 'md-col-6 rate-col xl-col-3'}`}>
              <div className={`rate-card ${item.isFull ? 'rate-card--full' : ''} w-full`}>
                <svg className="icon-beige rate-card__deco rate-card__semiround" width="40" height="53">
                  <use xlinkHref={semiroundShape.url} />
                </svg>
                <svg className="icon-gradient-blue rate-card__deco rate-card__hexagon" width="42" height="42">
                  <use xlinkHref={hexagonShape.url} />
                </svg>
                <svg className="icon-orange rate-card__deco rate-card__round" width="36" height="36">
                  <use xlinkHref={roundShape.url} />
                </svg>

                { !item.isFull ?
                  <>
                    <div>
                      <div className="flex flex-col items-center flex-shrink-0">
                        <p className="rate-card__title font-alternate">{item.title}</p>
                        {item.rate 
                         ? <p className="rate-card__price font-alternate rate-card__border-el">{item.rate.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}<span>€</span><span className="rate-card__period">/{trads[lang].offers[slugify(item.rateUnit, {remove: /[*+~.,()'"!?:@,]/g})]}</span></p>
                         : <p className="rate-card__border-el rate-card__price font-alternate rate-card__period mt-2">{trads[lang].offers['no-price']}</p>
                        }
                        {item.mention &&
                          <p className="rate-card__border-el rate-card__mention">{item.mention}</p>
                        }
                      </div>

                      <Wysiwyg document={item.content} noClass={true} classes="rate-card__desc mb-9" />
                    </div>
                    
                    { url &&
                      <ButtonArrow text={ cta.label } link={url} contentType={contentTypeContentful} color="ghost-night" icon={null} />
                    }
                  </>
                : 
                  <div className="row rate-card__row">
                    <div className="col-12 md-col-6 lg-col-4 xl-col-3 flex items-center">
                      <div className="md:pl-4 flex flex-col w-full items-center">
                        <p className="rate-card__title font-alternate">{item.title}</p>

                        {item.rate 
                         ? <p className="rate-card__price font-alternate rate-card__border-el">{item.rate.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}<span>€</span><span className="rate-card__period">/{trads[lang].offers[slugify(item.rateUnit, {remove: /[*+~.,()'"!?:@,]/g})]}</span></p>
                         : <p className="rate-card__border-el rate-card__price font-alternate rate-card__period mt-2">{trads[lang].offers['no-price']}</p>
                        }

                        {item.mention &&
                          <p className="rate-card__border-el rate-card__mention">{item.mention}</p>
                        }
                      </div>
                    </div>
                    <div className="col-12 md-col-6 lg-col-5 xl-col-6 xl:flex justify-between items-center text-center">
                      <Wysiwyg document={item.content} noClass={true} classes="rate-card__desc rate-card__desc--full" />
                      { url &&
                        <ButtonArrow text={ cta.label } link={url} contentType={contentTypeContentful} color="ghost-night" icon={null} />
                      }
                    </div>
                  </div>
                }
              </div>  
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default Rates